import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
export const SEARCH_MODES = [
    SearchMode.SEARCH,
    SearchMode.RESEARCH,
    SearchMode.AGENTIC_RESEARCH,
    SearchMode.STUDY,
    SearchMode.BROWSER_AGENT,
];
export function getSearchMenuOmittedModes({ omittedSearchModes, modes, }) {
    const omitted = new Set(omittedSearchModes);
    const allowed = new Set(modes);
    Object.values(SearchMode).forEach((mode) => {
        if (!allowed.has(mode)) {
            omitted.add(mode);
        }
    });
    return Array.from(omitted);
}
//# sourceMappingURL=mode-toggle-constants.js.map